/*
  Opens Rivo's account / loyalty slideout from the header account controls.

  Those controls used to be <a href="#rivo">. Nothing on the page has
  id="rivo", so that was a link to a named anchor that does not exist
  (WCAG 2.4.1) — it announced as a link and navigated nowhere. They are
  <button data-rivo-account-open> now, which is what they always were
  behaviourally: a dialog opener.

  Rivo's trigger is the '#rivo' HASH, not the anchor element — verified on the
  live theme: setting location.hash alone opens #rivo-account-slideout, with no
  anchor and no click on Rivo's own markup. Rivo clears the hash again when the
  panel closes, so a plain assignment re-fires hashchange on every click; the
  guard below covers the case where something leaves '#rivo' in the URL, since
  re-assigning an identical hash fires no event and the button would look dead.
*/
(function () {
  if (window.__rivoAccountTriggerWired) return;
  window.__rivoAccountTriggerWired = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rivo-account-open]');
    if (!trigger) return;

    event.preventDefault();

    if (window.location.hash === '#rivo') {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    window.location.hash = 'rivo';
  });
})();
